import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  label: {
    description: 'Font family label',
    defaultMessage: 'Font Family',
    id: 'faeNsV',
  },
});
